export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  EmailField: { input: any; output: any; }
};

export type Account = Node & {
  __typename?: 'Account';
  accountType: AccountTypeEnum;
  address?: Maybe<Address>;
  canManage: Scalars['Boolean']['output'];
  counts?: Maybe<Counts>;
  defaultIdentity?: Maybe<Identity>;
  deletionScheduledOn?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  features: Features;
  hasFreelanceProfiles: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  identities?: Maybe<Array<Identity>>;
  industrySector?: Maybe<Scalars['String']['output']>;
  language: LanguageEnum;
  logo?: Maybe<Attachment>;
  monogramPath?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nonProfit: Scalars['Boolean']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationNumber?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Account>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  primary: Scalars['Boolean']['output'];
  primaryUser?: Maybe<User>;
  role?: Maybe<TeamRoleEnum>;
  slug: Scalars['String']['output'];
  symbol?: Maybe<Attachment>;
  symbolDisplayPath?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<AccountTagEnum>;
  theme: AccountTheme;
  uiFlags: UiFlags;
  webhookUrl?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type AccountPagination = {
  __typename?: 'AccountPagination';
  exportPath?: Maybe<Scalars['String']['output']>;
  items: Array<Account>;
  total: Scalars['Int']['output'];
};

export enum AccountTagEnum {
  Generic = 'GENERIC',
  HealthServiceYouth = 'HEALTH_SERVICE_YOUTH',
  Kindergarten = 'KINDERGARTEN',
  KindergartenAndSchool = 'KINDERGARTEN_AND_SCHOOL',
  LanguageService = 'LANGUAGE_SERVICE',
  MarchingBand = 'MARCHING_BAND',
  Religious = 'RELIGIOUS',
  Sports = 'SPORTS',
  Volunteer = 'VOLUNTEER'
}

export type AccountTheme = {
  __typename?: 'AccountTheme';
  font?: Maybe<AccountThemeFont>;
  primary?: Maybe<Scalars['String']['output']>;
  primaryContrast?: Maybe<Scalars['String']['output']>;
  primaryHover?: Maybe<Scalars['String']['output']>;
};

export type AccountThemeFont = {
  __typename?: 'AccountThemeFont';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum AccountTypeEnum {
  Partner = 'PARTNER',
  Personal = 'PERSONAL',
  Team = 'TEAM'
}

export enum ActorEnum {
  Administrator = 'ADMINISTRATOR',
  Anonymous = 'ANONYMOUS',
  Client = 'CLIENT',
  Partner = 'PARTNER',
  System = 'SYSTEM',
  User = 'USER'
}

/** Autogenerated input type of AddAccountMember */
export type AddAccountMemberInput = {
  attributes: AddMemberAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AddAccountMember. */
export type AddAccountMemberPayload = {
  __typename?: 'AddAccountMemberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  member?: Maybe<Account>;
};

export type AddMemberAttributes = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  role: TeamRoleEnum;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
};

export type AddressAttributes = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  county?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  postalCode: Scalars['String']['input'];
};

/** Autogenerated input type of ApproveEnrollment */
export type ApproveEnrollmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ApproveEnrollment. */
export type ApproveEnrollmentPayload = {
  __typename?: 'ApproveEnrollmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  enrollment?: Maybe<Enrollment>;
  errors: Array<Error>;
};

/** Autogenerated input type of ArchiveClient */
export type ArchiveClientInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveClient. */
export type ArchiveClientPayload = {
  __typename?: 'ArchiveClientPayload';
  client: Client;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ArchiveFreelanceProfile */
export type ArchiveFreelanceProfileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveFreelanceProfile. */
export type ArchiveFreelanceProfilePayload = {
  __typename?: 'ArchiveFreelanceProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  freelanceProfile: FreelanceProfile;
};

export type Attachment = {
  __typename?: 'Attachment';
  contentType?: Maybe<Scalars['String']['output']>;
  downloadPath: Scalars['String']['output'];
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  thumbPath?: Maybe<Scalars['String']['output']>;
};

export type BankAccount = Node & {
  __typename?: 'BankAccount';
  accountNumber: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currency?: Maybe<CurrencyEnum>;
  default: Scalars['Boolean']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  swiftCode?: Maybe<Scalars['String']['output']>;
};

export type BankAccountAttributes = {
  accountNumber: Scalars['String']['input'];
  currency?: InputMaybe<CurrencyEnum>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<Scalars['String']['input']>;
};

export type Base64AttachmentAttributes = {
  data: Scalars['String']['input'];
  filename?: InputMaybe<Scalars['String']['input']>;
};

export type BenefitInvoiceLine = InvoiceLine & Node & {
  __typename?: 'BenefitInvoiceLine';
  amount: Scalars['Int']['output'];
  collapsed: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice: Invoice;
  lineType: LineTypeEnum;
  occupationCode: OccupationCode;
  quantity: Scalars['Float']['output'];
  remainingQuantity: Scalars['Float']['output'];
  unitPrice: Scalars['Int']['output'];
  vat: Scalars['Int']['output'];
  vatRate: Scalars['Float']['output'];
};

export type BulkInvoiceLineAttributes = {
  addressFrom?: InputMaybe<Scalars['String']['input']>;
  addressTo?: InputMaybe<Scalars['String']['input']>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dietNonTaxableUnitPrice?: InputMaybe<Scalars['Int']['input']>;
  dietTaxableUnitPrice?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lineType?: InputMaybe<LineTypeEnum>;
  occupationCodeId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Int']['input']>;
  vatRate?: InputMaybe<Scalars['Float']['input']>;
  workInvoiceLineId?: InputMaybe<Scalars['ID']['input']>;
  workReport?: InputMaybe<WorkReportAttributes>;
};

/** Autogenerated input type of CancelAccountDeletion */
export type CancelAccountDeletionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CancelAccountDeletion. */
export type CancelAccountDeletionPayload = {
  __typename?: 'CancelAccountDeletionPayload';
  account?: Maybe<Account>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Invoice receiver */
export type Client = Node & {
  __typename?: 'Client';
  address?: Maybe<Address>;
  archivedAt?: Maybe<Scalars['String']['output']>;
  /** Unique identifier to be used in accounting systems */
  clientNumber: Scalars['Int']['output'];
  clientType: ClientTypeEnum;
  email?: Maybe<Scalars['String']['output']>;
  friendlyName?: Maybe<Scalars['String']['output']>;
  helpArticle?: Maybe<HelpArticle>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nationalRegisterCheck: Scalars['Boolean']['output'];
  orgNumber?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  preferredDeliveryMethod: ClientPreferredDeliveryMethodEnum;
  referencePeople: Array<ReferencePerson>;
};

export type ClientPagination = {
  __typename?: 'ClientPagination';
  exportPath?: Maybe<Scalars['String']['output']>;
  items: Array<Client>;
  total: Scalars['Int']['output'];
};

export enum ClientPreferredDeliveryMethodEnum {
  Ehf = 'EHF',
  Email = 'EMAIL',
  None = 'NONE'
}

export enum ClientTypeEnum {
  Individual = 'INDIVIDUAL',
  Organization = 'ORGANIZATION'
}

export type ClientsFilter = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  clientType?: InputMaybe<ClientTypeEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum ClientsSortByEnum {
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export type Company = {
  __typename?: 'Company';
  address?: Maybe<Address>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  markedAsBankruptcy?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  orgNumber: Scalars['String']['output'];
  underForcedLiquidation?: Maybe<Scalars['Boolean']['output']>;
  underLiquidation?: Maybe<Scalars['Boolean']['output']>;
};

export enum CountryCodeEnum {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW'
}

export type Counts = {
  __typename?: 'Counts';
  members: Scalars['Int']['output'];
};

export type CreateAccountAttributes = {
  name: Scalars['String']['input'];
};

/** Autogenerated input type of CreateBankAccount */
export type CreateBankAccountInput = {
  attributes: BankAccountAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  freelanceProfileId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateBankAccount. */
export type CreateBankAccountPayload = {
  __typename?: 'CreateBankAccountPayload';
  bankAccount?: Maybe<BankAccount>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

export type CreateClientAttributes = {
  address: AddressAttributes;
  clientNumber?: InputMaybe<Scalars['Int']['input']>;
  clientNumberSeries?: InputMaybe<RangeAttributes>;
  clientType: ClientTypeEnum;
  email?: InputMaybe<Scalars['String']['input']>;
  freelanceProfileId: Scalars['ID']['input'];
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationalRegisterCheck?: InputMaybe<Scalars['Boolean']['input']>;
  orgNumber?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preferredDeliveryMethod?: InputMaybe<ClientPreferredDeliveryMethodEnum>;
  referencePeople?: InputMaybe<Array<ReferencePersonAttributes>>;
};

/** Autogenerated input type of CreateClient */
export type CreateClientInput = {
  attributes: CreateClientAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateClient. */
export type CreateClientPayload = {
  __typename?: 'CreateClientPayload';
  client?: Maybe<Client>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateCreditNote */
export type CreateCreditNoteInput = {
  attributes: CreditNoteAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateCreditNote. */
export type CreateCreditNotePayload = {
  __typename?: 'CreateCreditNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  creditNote?: Maybe<CreditNote>;
  errors: Array<Error>;
};

export type CreateFreelanceProfileAttributes = {
  address: AddressAttributes;
  bankAccount: BankAccountAttributes;
  country?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freelanceType: FreelanceTypeEnum;
  invoiceLogo?: InputMaybe<Base64AttachmentAttributes>;
  invoiceStartingNumber?: InputMaybe<Scalars['Int']['input']>;
  journalFormat?: InputMaybe<JournalFormatEnum>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
  personalNumber?: InputMaybe<Scalars['String']['input']>;
  referencePeople?: InputMaybe<Array<ReferencePersonAttributes>>;
};

/** Autogenerated input type of CreateFreelanceProfile */
export type CreateFreelanceProfileInput = {
  attributes: CreateFreelanceProfileAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateFreelanceProfile. */
export type CreateFreelanceProfilePayload = {
  __typename?: 'CreateFreelanceProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  freelanceProfile?: Maybe<FreelanceProfile>;
};

export type CreateInvoiceAttributes = {
  bankAccountId?: InputMaybe<Scalars['ID']['input']>;
  buyerReference?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['ID']['input'];
  clientReferencePerson?: InputMaybe<ReferencePersonAttributes>;
  dueOn?: InputMaybe<Scalars['String']['input']>;
  invoicedOn?: InputMaybe<Scalars['String']['input']>;
  lines?: InputMaybe<Array<BulkInvoiceLineAttributes>>;
  orderReference?: InputMaybe<Scalars['String']['input']>;
  senderReferencePerson?: InputMaybe<ReferencePersonAttributes>;
};

/** Autogenerated input type of CreateInvoice */
export type CreateInvoiceInput = {
  attributes: CreateInvoiceAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInvoiceLineAttributes = {
  addressFrom?: InputMaybe<Scalars['String']['input']>;
  addressTo?: InputMaybe<Scalars['String']['input']>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dietNonTaxableUnitPrice?: InputMaybe<Scalars['Int']['input']>;
  dietTaxableUnitPrice?: InputMaybe<Scalars['Int']['input']>;
  lineType: LineTypeEnum;
  occupationCodeId: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Int']['input']>;
  vatRate?: InputMaybe<Scalars['Float']['input']>;
  workInvoiceLineId?: InputMaybe<Scalars['ID']['input']>;
  workReport?: InputMaybe<WorkReportAttributes>;
};

/** Autogenerated input type of CreateInvoiceLine */
export type CreateInvoiceLineInput = {
  attributes: CreateInvoiceLineAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateInvoiceLine. */
export type CreateInvoiceLinePayload = {
  __typename?: 'CreateInvoiceLinePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  invoiceLine?: Maybe<InvoiceLine>;
};

/** Autogenerated return type of CreateInvoice. */
export type CreateInvoicePayload = {
  __typename?: 'CreateInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  invoice?: Maybe<Invoice>;
};

/** Autogenerated input type of CreateJournal */
export type CreateJournalInput = {
  attributes: JournalAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateJournal. */
export type CreateJournalPayload = {
  __typename?: 'CreateJournalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateReceipt */
export type CreateReceiptInput = {
  attributes: ReceiptAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateReceipt. */
export type CreateReceiptPayload = {
  __typename?: 'CreateReceiptPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  receipt?: Maybe<Receipt>;
};

/** Autogenerated input type of CreateSessionOtp */
export type CreateSessionOtpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['EmailField']['input'];
};

/** Autogenerated return type of CreateSessionOtp. */
export type CreateSessionOtpPayload = {
  __typename?: 'CreateSessionOtpPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateTeamAccount */
export type CreateTeamAccountInput = {
  attributes: CreateAccountAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateTeamAccount. */
export type CreateTeamAccountPayload = {
  __typename?: 'CreateTeamAccountPayload';
  account?: Maybe<Account>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

export type CreateTransferAttributes = {
  amount: Scalars['Int']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fromFinanceAccount?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['ID']['input'];
  toFinanceAccount?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CreateTransfer */
export type CreateTransferInput = {
  attributes: CreateTransferAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateTransfer. */
export type CreateTransferPayload = {
  __typename?: 'CreateTransferPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  transfer?: Maybe<Transfer>;
};

export type CreditNote = Node & {
  __typename?: 'CreditNote';
  amount: Scalars['Int']['output'];
  approvedAt?: Maybe<Scalars['String']['output']>;
  client?: Maybe<Client>;
  creditNoteNumber?: Maybe<Scalars['String']['output']>;
  creditedOn?: Maybe<Scalars['String']['output']>;
  currency: CurrencyEnum;
  ehfSentAt?: Maybe<Scalars['String']['output']>;
  emailSentAt?: Maybe<Scalars['String']['output']>;
  employerTaxAmount?: Maybe<Scalars['Int']['output']>;
  events?: Maybe<Array<CreditNoteEvent>>;
  freelanceProfile: FreelanceProfile;
  grossSalary?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  invoice: Invoice;
  lines: Array<CreditNoteLine>;
  payoutAmount?: Maybe<Scalars['Int']['output']>;
  pdfDocument?: Maybe<Attachment>;
  platformFeeAmount?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['String']['output']>;
  rejectedAt?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['String']['output']>;
  salaryTaxAmount?: Maybe<Scalars['Int']['output']>;
  status: InvoiceStatusEnum;
  vat: Scalars['Int']['output'];
};

export type CreditNoteAttributes = {
  invoiceId: Scalars['ID']['input'];
  lines: Array<CreditNoteLineAttributes>;
};

export type CreditNoteEvent = {
  __typename?: 'CreditNoteEvent';
  actor: ActorEnum;
  eventType: CreditNoteEventTypeEnum;
  occurredAt: Scalars['String']['output'];
  status: InvoiceStatusEnum;
};

export enum CreditNoteEventTypeEnum {
  CreditNoteApproved = 'CREDIT_NOTE_APPROVED',
  CreditNoteApprovedForDeduction = 'CREDIT_NOTE_APPROVED_FOR_DEDUCTION',
  CreditNoteDeducted = 'CREDIT_NOTE_DEDUCTED',
  CreditNoteEhfRequested = 'CREDIT_NOTE_EHF_REQUESTED',
  CreditNotePublished = 'CREDIT_NOTE_PUBLISHED',
  CreditNotePublishedOnTripletex = 'CREDIT_NOTE_PUBLISHED_ON_TRIPLETEX',
  CreditNoteRejected = 'CREDIT_NOTE_REJECTED',
  CreditNoteRejectedForDeduction = 'CREDIT_NOTE_REJECTED_FOR_DEDUCTION',
  CreditNoteResolved = 'CREDIT_NOTE_RESOLVED',
  CreditNoteSentManually = 'CREDIT_NOTE_SENT_MANUALLY',
  CreditNoteSentViaEhf = 'CREDIT_NOTE_SENT_VIA_EHF',
  CreditNoteSentViaEmail = 'CREDIT_NOTE_SENT_VIA_EMAIL',
  CreditNoteSubmitted = 'CREDIT_NOTE_SUBMITTED',
  CreditNoteUnapprovedForDeduction = 'CREDIT_NOTE_UNAPPROVED_FOR_DEDUCTION'
}

export type CreditNoteLine = Node & {
  __typename?: 'CreditNoteLine';
  amount: Scalars['Int']['output'];
  creditNote: CreditNote;
  description?: Maybe<Scalars['String']['output']>;
  employerTaxAmount?: Maybe<Scalars['Int']['output']>;
  grossSalary?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  invoiceLine: InvoiceLine;
  payoutAmount?: Maybe<Scalars['Int']['output']>;
  platformFeeAmount?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Float']['output'];
  salaryTaxAmount?: Maybe<Scalars['Int']['output']>;
  vat: Scalars['Int']['output'];
};

export type CreditNoteLineAttributes = {
  description: Scalars['String']['input'];
  invoiceLineId: Scalars['ID']['input'];
  quantity: Scalars['Float']['input'];
};

export type CreditNotePagination = {
  __typename?: 'CreditNotePagination';
  exportPath?: Maybe<Scalars['String']['output']>;
  items: Array<CreditNote>;
  total: Scalars['Int']['output'];
};

export type CreditNotesFilter = {
  amountFrom?: InputMaybe<Scalars['Int']['input']>;
  amountTo?: InputMaybe<Scalars['Int']['input']>;
  clientExclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  clientInclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  creditedOnFrom?: InputMaybe<Scalars['String']['input']>;
  creditedOnTo?: InputMaybe<Scalars['String']['input']>;
  freelanceProfileId?: InputMaybe<Scalars['ID']['input']>;
  publishedAtFrom?: InputMaybe<Scalars['String']['input']>;
  publishedAtTo?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statusExclude?: InputMaybe<Array<InvoiceStatusEnum>>;
  statusInclude?: InputMaybe<Array<InvoiceStatusEnum>>;
};

export enum CreditNotesSortByEnum {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  ClientNameAsc = 'CLIENT_NAME_ASC',
  ClientNameDesc = 'CLIENT_NAME_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreditNoteNumberNumberAsc = 'CREDIT_NOTE_NUMBER_NUMBER_ASC',
  CreditNoteNumberNumberDesc = 'CREDIT_NOTE_NUMBER_NUMBER_DESC',
  PublishedAtAsc = 'PUBLISHED_AT_ASC',
  PublishedAtDesc = 'PUBLISHED_AT_DESC'
}

/** Autogenerated input type of CriiptoVerify */
export type CriiptoVerifyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
};

/** Autogenerated return type of CriiptoVerify. */
export type CriiptoVerifyPayload = {
  __typename?: 'CriiptoVerifyPayload';
  account?: Maybe<Account>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

export enum CurrencyEnum {
  Chf = 'CHF',
  Czk = 'CZK',
  Dkk = 'DKK',
  Eur = 'EUR',
  Gbp = 'GBP',
  Isk = 'ISK',
  Nok = 'NOK',
  Pln = 'PLN',
  Sek = 'SEK',
  Uah = 'UAH',
  Usd = 'USD'
}

/** Autogenerated input type of DeleteAccount */
export type DeleteAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeleteAccount. */
export type DeleteAccountPayload = {
  __typename?: 'DeleteAccountPayload';
  account?: Maybe<Account>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of DeleteIdentity */
export type DeleteIdentityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteIdentity. */
export type DeleteIdentityPayload = {
  __typename?: 'DeleteIdentityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  identity?: Maybe<Identity>;
};

/** Autogenerated input type of DestroyAccountLogo */
export type DestroyAccountLogoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DestroyAccountLogo. */
export type DestroyAccountLogoPayload = {
  __typename?: 'DestroyAccountLogoPayload';
  account: Account;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyAccountSymbol */
export type DestroyAccountSymbolInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  personal?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of DestroyAccountSymbol. */
export type DestroyAccountSymbolPayload = {
  __typename?: 'DestroyAccountSymbolPayload';
  account?: Maybe<Account>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyBankAccount */
export type DestroyBankAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyBankAccount. */
export type DestroyBankAccountPayload = {
  __typename?: 'DestroyBankAccountPayload';
  bankAccount?: Maybe<BankAccount>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of DestroyInvoice */
export type DestroyInvoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated input type of DestroyInvoiceLine */
export type DestroyInvoiceLineInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyInvoiceLine. */
export type DestroyInvoiceLinePayload = {
  __typename?: 'DestroyInvoiceLinePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated return type of DestroyInvoice. */
export type DestroyInvoicePayload = {
  __typename?: 'DestroyInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of DestroyReceipt */
export type DestroyReceiptInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyReceipt. */
export type DestroyReceiptPayload = {
  __typename?: 'DestroyReceiptPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of DestroyTransfer */
export type DestroyTransferInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyTransfer. */
export type DestroyTransferPayload = {
  __typename?: 'DestroyTransferPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

export type DietInvoiceLine = InvoiceLine & Node & {
  __typename?: 'DietInvoiceLine';
  amount: Scalars['Int']['output'];
  collapsed: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dietNonTaxableUnitPrice: Scalars['Int']['output'];
  dietTaxableUnitPrice: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  invoice: Invoice;
  lineType: LineTypeEnum;
  occupationCode: OccupationCode;
  quantity: Scalars['Float']['output'];
  remainingQuantity: Scalars['Float']['output'];
  unitPrice: Scalars['Int']['output'];
  vat: Scalars['Int']['output'];
  vatRate: Scalars['Float']['output'];
};

/** Autogenerated input type of DuplicateInvoice */
export type DuplicateInvoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DuplicateInvoice. */
export type DuplicateInvoicePayload = {
  __typename?: 'DuplicateInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  invoice?: Maybe<Invoice>;
};

export type Enrollment = Node & {
  __typename?: 'Enrollment';
  account: Account;
  approved: Scalars['Boolean']['output'];
  bankAccounts?: Maybe<BankAccount>;
  freelanceProfile?: Maybe<FreelanceProfile>;
  id: Scalars['ID']['output'];
  locked: Scalars['Boolean']['output'];
  partnerAccount: Account;
};

export type Error = {
  __typename?: 'Error';
  code: ErrorCodeEnum;
  message?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum ErrorCodeEnum {
  AccountBlocked = 'ACCOUNT_BLOCKED',
  AccountNotFound = 'ACCOUNT_NOT_FOUND',
  AttemptsLimitExceeded = 'ATTEMPTS_LIMIT_EXCEEDED',
  AuthLevel_2Required = 'AUTH_LEVEL_2_REQUIRED',
  BankidRequired = 'BANKID_REQUIRED',
  BankIdVerificationRequired = 'BANK_ID_VERIFICATION_REQUIRED',
  Blank = 'BLANK',
  BrregQueryFailed = 'BRREG_QUERY_FAILED',
  ClientDeleted = 'CLIENT_DELETED',
  ClientEmailMissing = 'CLIENT_EMAIL_MISSING',
  ClientInsolvent = 'CLIENT_INSOLVENT',
  DeliveredByAccountingSystem = 'DELIVERED_BY_ACCOUNTING_SYSTEM',
  DeliveryFrequencyExceeded = 'DELIVERY_FREQUENCY_EXCEEDED',
  DeliveryRouteRequired = 'DELIVERY_ROUTE_REQUIRED',
  DocumentNotFound = 'DOCUMENT_NOT_FOUND',
  DocumentSigned = 'DOCUMENT_SIGNED',
  EndClientRequiresApprovedEnrollment = 'END_CLIENT_REQUIRES_APPROVED_ENROLLMENT',
  Forbidden = 'FORBIDDEN',
  FreelanceProfileArchived = 'FREELANCE_PROFILE_ARCHIVED',
  FutureWorkDate = 'FUTURE_WORK_DATE',
  IdentifierLocked = 'IDENTIFIER_LOCKED',
  IdentifierNotInRegister = 'IDENTIFIER_NOT_IN_REGISTER',
  IdentityBelongsToAnotherEmail = 'IDENTITY_BELONGS_TO_ANOTHER_EMAIL',
  IdentityWriteNotPermitted = 'IDENTITY_WRITE_NOT_PERMITTED',
  Immutable = 'IMMUTABLE',
  ImportError = 'IMPORT_ERROR',
  Inclusion = 'INCLUSION',
  IndividualAlreadyExists = 'INDIVIDUAL_ALREADY_EXISTS',
  IndividualProfileCannotInvoice = 'INDIVIDUAL_PROFILE_CANNOT_INVOICE',
  Invalid = 'INVALID',
  InvalidAction = 'INVALID_ACTION',
  InvalidInvoicedOn = 'INVALID_INVOICED_ON',
  InvalidNorwegianAccountNumber = 'INVALID_NORWEGIAN_ACCOUNT_NUMBER',
  InvalidPassword = 'INVALID_PASSWORD',
  InvalidPhoneNumber = 'INVALID_PHONE_NUMBER',
  InvalidToken = 'INVALID_TOKEN',
  InvalidTransition = 'INVALID_TRANSITION',
  InvoiceCalculationFailed = 'INVOICE_CALCULATION_FAILED',
  InvoiceNotCredited = 'INVOICE_NOT_CREDITED',
  InvoiceNotOrganization = 'INVOICE_NOT_ORGANIZATION',
  InvoiceNotPublished = 'INVOICE_NOT_PUBLISHED',
  InvoiceNotSubmitted = 'INVOICE_NOT_SUBMITTED',
  InvoicePublished = 'INVOICE_PUBLISHED',
  InvoiceSubmitted = 'INVOICE_SUBMITTED',
  InFuture = 'IN_FUTURE',
  JobDisabled = 'JOB_DISABLED',
  LineMismatch = 'LINE_MISMATCH',
  MissingFreelancerDetails = 'MISSING_FREELANCER_DETAILS',
  OccupationCodeDisabled = 'OCCUPATION_CODE_DISABLED',
  OrganizationDeleted = 'ORGANIZATION_DELETED',
  OrganizationRoleCheckFailed = 'ORGANIZATION_ROLE_CHECK_FAILED',
  OrphanedSubLine = 'ORPHANED_SUB_LINE',
  OtpExpired = 'OTP_EXPIRED',
  OtpExpiredAndResent = 'OTP_EXPIRED_AND_RESENT',
  PartnerCallbackError = 'PARTNER_CALLBACK_ERROR',
  PersonalAccountOwnsTeams = 'PERSONAL_ACCOUNT_OWNS_TEAMS',
  PersonalNumberMismatch = 'PERSONAL_NUMBER_MISMATCH',
  Present = 'PRESENT',
  RecipientNotAllowed = 'RECIPIENT_NOT_ALLOWED',
  SenderEqualsReceiver = 'SENDER_EQUALS_RECEIVER',
  SmsSendingFailed = 'SMS_SENDING_FAILED',
  SubscriptionLimitExceeded = 'SUBSCRIPTION_LIMIT_EXCEEDED',
  Taken = 'TAKEN',
  TokenExpired = 'TOKEN_EXPIRED',
  TooBig = 'TOO_BIG',
  TooBigOrEqual = 'TOO_BIG_OR_EQUAL',
  TooShort = 'TOO_SHORT',
  TooSmall = 'TOO_SMALL',
  TooSmallOrEqual = 'TOO_SMALL_OR_EQUAL',
  TransitionFailed = 'TRANSITION_FAILED',
  Unauthorized = 'UNAUTHORIZED',
  UserAlreadyConfirmed = 'USER_ALREADY_CONFIRMED',
  UserBlocked = 'USER_BLOCKED',
  UserExists = 'USER_EXISTS',
  UserNotConfirmed = 'USER_NOT_CONFIRMED',
  UserNotFound = 'USER_NOT_FOUND',
  ValidationFailed = 'VALIDATION_FAILED',
  VerificationFailed = 'VERIFICATION_FAILED',
  WorkHoursDailyLimitExceeded = 'WORK_HOURS_DAILY_LIMIT_EXCEEDED',
  WorkHoursMonthlyLimitExceeded = 'WORK_HOURS_MONTHLY_LIMIT_EXCEEDED',
  WorkHoursWeeklyLimitExceeded = 'WORK_HOURS_WEEKLY_LIMIT_EXCEEDED',
  WorkPeriodInvoiceMonthMismatch = 'WORK_PERIOD_INVOICE_MONTH_MISMATCH'
}

export type ExpenseInvoiceLine = InvoiceLine & Node & {
  __typename?: 'ExpenseInvoiceLine';
  amount: Scalars['Int']['output'];
  collapsed: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice: Invoice;
  lineType: LineTypeEnum;
  occupationCode: OccupationCode;
  quantity: Scalars['Float']['output'];
  remainingQuantity: Scalars['Float']['output'];
  unitPrice: Scalars['Int']['output'];
  vat: Scalars['Int']['output'];
  vatRate: Scalars['Float']['output'];
};

export type ExtraInvoiceLine = InvoiceLine & Node & {
  __typename?: 'ExtraInvoiceLine';
  amount: Scalars['Int']['output'];
  collapsed: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice: Invoice;
  lineType: LineTypeEnum;
  occupationCode: OccupationCode;
  quantity: Scalars['Float']['output'];
  remainingQuantity: Scalars['Float']['output'];
  unitPrice: Scalars['Int']['output'];
  vat: Scalars['Int']['output'];
  vatRate: Scalars['Float']['output'];
};

export type Features = {
  __typename?: 'Features';
  nonNokInvoicing: Scalars['Boolean']['output'];
  payoutSplit: Scalars['Boolean']['output'];
};

export type FreelanceProfile = Node & {
  __typename?: 'FreelanceProfile';
  address?: Maybe<Address>;
  agreementPdf?: Maybe<Attachment>;
  archivedAt?: Maybe<Scalars['String']['output']>;
  bankAccounts?: Maybe<Array<BankAccount>>;
  defaultBankAccount?: Maybe<BankAccount>;
  firstName?: Maybe<Scalars['String']['output']>;
  freelanceType: FreelanceTypeEnum;
  id: Scalars['ID']['output'];
  invoiceLogo?: Maybe<Attachment>;
  invoiceStartingNumber?: Maybe<Scalars['Int']['output']>;
  journalClosedMonth?: Maybe<Scalars['String']['output']>;
  journalFormat?: Maybe<JournalFormatEnum>;
  journals?: Maybe<Array<Journal>>;
  lastName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationNumber?: Maybe<Scalars['String']['output']>;
  referencePeople: Array<ReferencePerson>;
  taxCardStatus?: Maybe<Scalars['Boolean']['output']>;
  verified: Scalars['Boolean']['output'];
};

export type FreelanceProfilePagination = {
  __typename?: 'FreelanceProfilePagination';
  exportPath?: Maybe<Scalars['String']['output']>;
  items: Array<FreelanceProfile>;
  total: Scalars['Int']['output'];
};

export type FreelanceProfilesFilter = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  freelanceType?: InputMaybe<FreelanceTypeEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum FreelanceProfilesSortByEnum {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC'
}

export enum FreelanceTypeEnum {
  Individual = 'INDIVIDUAL',
  Organization = 'ORGANIZATION'
}

export type HelpArticle = {
  __typename?: 'HelpArticle';
  blockManualInvoicing: Scalars['Boolean']['output'];
  enHelpArticleUrl?: Maybe<Scalars['String']['output']>;
  enMessage?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nbHelpArticleUrl?: Maybe<Scalars['String']['output']>;
  nbMessage?: Maybe<Scalars['String']['output']>;
  showAttachmentWarning: Scalars['Boolean']['output'];
  supportEmail?: Maybe<Scalars['String']['output']>;
};

export type Identity = Node & {
  __typename?: 'Identity';
  country: CountryCodeEnum;
  createdAt: Scalars['String']['output'];
  dateOfBirth: Scalars['String']['output'];
  default: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  temporary: Scalars['Boolean']['output'];
  updatedAt: Scalars['String']['output'];
};

export type Invoice = Node & {
  __typename?: 'Invoice';
  amount: Scalars['Int']['output'];
  approvedAt?: Maybe<Scalars['String']['output']>;
  bankAccount?: Maybe<BankAccount>;
  bankAccountNumber?: Maybe<Scalars['String']['output']>;
  bankSwiftCode?: Maybe<Scalars['String']['output']>;
  bundled: Scalars['Boolean']['output'];
  buyerReference?: Maybe<Scalars['String']['output']>;
  client?: Maybe<Client>;
  clientReferencePerson?: Maybe<ReferencePerson>;
  createdAt: Scalars['String']['output'];
  creditNotes: Array<CreditNote>;
  currency?: Maybe<CurrencyEnum>;
  dueOn?: Maybe<Scalars['String']['output']>;
  ehfSentAt?: Maybe<Scalars['String']['output']>;
  emailSentAt?: Maybe<Scalars['String']['output']>;
  employerTax?: Maybe<Scalars['Float']['output']>;
  employerTaxAmount?: Maybe<Scalars['Int']['output']>;
  events?: Maybe<Array<InvoiceEvent>>;
  freelanceProfile: FreelanceProfile;
  grossSalary?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  invoicedOn?: Maybe<Scalars['String']['output']>;
  kid?: Maybe<Scalars['String']['output']>;
  lines: Array<InvoiceLine>;
  nullifiedAt?: Maybe<Scalars['String']['output']>;
  orderReference?: Maybe<Scalars['String']['output']>;
  payoutAmount?: Maybe<Scalars['Int']['output']>;
  pdfDocument?: Maybe<Attachment>;
  platformFee?: Maybe<Scalars['Float']['output']>;
  platformFeeAmount?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['String']['output']>;
  receipts: Array<Receipt>;
  refundStatus: InvoiceRefundStatusEnum;
  rejectedAt?: Maybe<Scalars['String']['output']>;
  remainingAmount: Scalars['Int']['output'];
  remainingEmployerTaxAmount: Scalars['Int']['output'];
  remainingGrossSalary: Scalars['Int']['output'];
  remainingPayoutAmount: Scalars['Int']['output'];
  remainingPlatformFeeAmount: Scalars['Int']['output'];
  remainingSalaryTaxAmount: Scalars['Int']['output'];
  remainingVat: Scalars['Int']['output'];
  resolvedAt?: Maybe<Scalars['String']['output']>;
  salaryTax?: Maybe<Scalars['Float']['output']>;
  salaryTaxAmount?: Maybe<Scalars['Int']['output']>;
  senderReferencePerson?: Maybe<ReferencePerson>;
  senderVatRegistered: Scalars['Boolean']['output'];
  status: InvoiceStatusEnum;
  submittedAt?: Maybe<Scalars['String']['output']>;
  transfers?: Maybe<Array<Transfer>>;
  vat: Scalars['Int']['output'];
};

export type InvoiceEvent = {
  __typename?: 'InvoiceEvent';
  actor: ActorEnum;
  eventType: InvoiceEventTypeEnum;
  occurredAt: Scalars['String']['output'];
  status: InvoiceStatusEnum;
};

export enum InvoiceEventTypeEnum {
  InvoiceApproved = 'INVOICE_APPROVED',
  InvoiceApprovedForPayout = 'INVOICE_APPROVED_FOR_PAYOUT',
  InvoiceCredited = 'INVOICE_CREDITED',
  InvoiceEhfRequested = 'INVOICE_EHF_REQUESTED',
  InvoiceHidden = 'INVOICE_HIDDEN',
  InvoiceNullified = 'INVOICE_NULLIFIED',
  InvoicePaidOut = 'INVOICE_PAID_OUT',
  InvoicePublished = 'INVOICE_PUBLISHED',
  InvoicePublishedOnFiken = 'INVOICE_PUBLISHED_ON_FIKEN',
  InvoicePublishedOnTripletex = 'INVOICE_PUBLISHED_ON_TRIPLETEX',
  InvoiceRejected = 'INVOICE_REJECTED',
  InvoiceRejectedForPayout = 'INVOICE_REJECTED_FOR_PAYOUT',
  InvoiceReminderSent = 'INVOICE_REMINDER_SENT',
  InvoiceResolved = 'INVOICE_RESOLVED',
  InvoiceSentManually = 'INVOICE_SENT_MANUALLY',
  InvoiceSentViaEhf = 'INVOICE_SENT_VIA_EHF',
  InvoiceSentViaEmail = 'INVOICE_SENT_VIA_EMAIL',
  InvoiceSettled = 'INVOICE_SETTLED',
  InvoiceSubmitted = 'INVOICE_SUBMITTED',
  InvoiceUnapproved = 'INVOICE_UNAPPROVED',
  InvoiceUnapprovedForPayout = 'INVOICE_UNAPPROVED_FOR_PAYOUT',
  InvoiceUnpublished = 'INVOICE_UNPUBLISHED',
  InvoiceUnrejected = 'INVOICE_UNREJECTED',
  InvoiceVoided = 'INVOICE_VOIDED',
  PayoutHeld = 'PAYOUT_HELD',
  PayoutNullified = 'PAYOUT_NULLIFIED',
  PayoutReleased = 'PAYOUT_RELEASED'
}

export type InvoiceLine = {
  amount: Scalars['Int']['output'];
  collapsed: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice: Invoice;
  lineType: LineTypeEnum;
  occupationCode: OccupationCode;
  quantity: Scalars['Float']['output'];
  remainingQuantity: Scalars['Float']['output'];
  unitPrice: Scalars['Int']['output'];
  vat: Scalars['Int']['output'];
  vatRate: Scalars['Float']['output'];
};

export type InvoicePagination = {
  __typename?: 'InvoicePagination';
  exportPath?: Maybe<Scalars['String']['output']>;
  items: Array<Invoice>;
  total: Scalars['Int']['output'];
};

export enum InvoiceRefundStatusEnum {
  Full = 'FULL',
  No = 'NO',
  Partial = 'PARTIAL',
  Pending = 'PENDING'
}

export enum InvoiceStatusEnum {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Nullified = 'NULLIFIED',
  Published = 'PUBLISHED',
  Rejected = 'REJECTED',
  Resolved = 'RESOLVED',
  Submitted = 'SUBMITTED'
}

export type InvoicesFilter = {
  amountFrom?: InputMaybe<Scalars['Int']['input']>;
  amountnTo?: InputMaybe<Scalars['Int']['input']>;
  clientExclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  clientInclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  freelanceProfileId?: InputMaybe<Scalars['ID']['input']>;
  invoicedOnFrom?: InputMaybe<Scalars['String']['input']>;
  invoicedOnTo?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statusExclude?: InputMaybe<Array<InvoiceStatusEnum>>;
  statusInclude?: InputMaybe<Array<InvoiceStatusEnum>>;
  submittedAtFrom?: InputMaybe<Scalars['String']['input']>;
  submittedAtTo?: InputMaybe<Scalars['String']['input']>;
};

export enum InvoicesSortByEnum {
  AmountAsc = 'AMOUNT_ASC',
  AmountDesc = 'AMOUNT_DESC',
  ClientNameAsc = 'CLIENT_NAME_ASC',
  ClientNameDesc = 'CLIENT_NAME_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  InvoiceNumberAsc = 'INVOICE_NUMBER_ASC',
  InvoiceNumberDesc = 'INVOICE_NUMBER_DESC',
  SubmittedAtAsc = 'SUBMITTED_AT_ASC',
  SubmittedAtDesc = 'SUBMITTED_AT_DESC'
}

export type Journal = Node & {
  __typename?: 'Journal';
  amountWithVat: Scalars['Int']['output'];
  exportType: JournalTypeEnum;
  format: JournalFormatEnum;
  id: Scalars['ID']['output'];
  month: Scalars['String']['output'];
  sequenceNumber: Scalars['Int']['output'];
};

export type JournalAttributes = {
  exportType: JournalTypeEnum;
  freelanceProfileId: Scalars['ID']['input'];
  month: Scalars['String']['input'];
};

export enum JournalFormatEnum {
  Tripletex = 'TRIPLETEX',
  Visma = 'VISMA'
}

export enum JournalTypeEnum {
  CreditNote = 'CREDIT_NOTE',
  Invoice = 'INVOICE'
}

export enum LanguageEnum {
  En = 'EN',
  Nb = 'NB'
}

export enum LineTypeEnum {
  Benefit = 'BENEFIT',
  Diet = 'DIET',
  Expense = 'EXPENSE',
  Extra = 'EXTRA',
  Mileage = 'MILEAGE',
  Work = 'WORK'
}

export type ListCompany = {
  __typename?: 'ListCompany';
  accountExists: Scalars['Boolean']['output'];
  address?: Maybe<Address>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  markedAsBankruptcy?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  orgNumber: Scalars['String']['output'];
  underForcedLiquidation?: Maybe<Scalars['Boolean']['output']>;
  underLiquidation?: Maybe<Scalars['Boolean']['output']>;
};

export type ListCompanyPagination = {
  __typename?: 'ListCompanyPagination';
  exportPath?: Maybe<Scalars['String']['output']>;
  items: Array<ListCompany>;
  total: Scalars['Int']['output'];
};

export type MembersFilter = {
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type MileageInvoiceLine = InvoiceLine & Node & {
  __typename?: 'MileageInvoiceLine';
  addressFrom?: Maybe<Scalars['String']['output']>;
  addressTo?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Int']['output'];
  collapsed: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice: Invoice;
  lineType: LineTypeEnum;
  occupationCode: OccupationCode;
  quantity: Scalars['Float']['output'];
  remainingQuantity: Scalars['Float']['output'];
  unitPrice: Scalars['Int']['output'];
  vat: Scalars['Int']['output'];
  vatRate: Scalars['Float']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addAccountMember?: Maybe<AddAccountMemberPayload>;
  approveEnrollment?: Maybe<ApproveEnrollmentPayload>;
  archiveClient?: Maybe<ArchiveClientPayload>;
  archiveFreelanceProfile?: Maybe<ArchiveFreelanceProfilePayload>;
  cancelAccountDeletion?: Maybe<CancelAccountDeletionPayload>;
  createBankAccount?: Maybe<CreateBankAccountPayload>;
  createClient?: Maybe<CreateClientPayload>;
  createCreditNote?: Maybe<CreateCreditNotePayload>;
  createFreelanceProfile?: Maybe<CreateFreelanceProfilePayload>;
  createInvoice?: Maybe<CreateInvoicePayload>;
  createInvoiceLine?: Maybe<CreateInvoiceLinePayload>;
  createJournal?: Maybe<CreateJournalPayload>;
  createReceipt?: Maybe<CreateReceiptPayload>;
  createSessionOtp?: Maybe<CreateSessionOtpPayload>;
  createTeamAccount?: Maybe<CreateTeamAccountPayload>;
  createTransfer?: Maybe<CreateTransferPayload>;
  criiptoVerify?: Maybe<CriiptoVerifyPayload>;
  deleteAccount?: Maybe<DeleteAccountPayload>;
  deleteIdentity?: Maybe<DeleteIdentityPayload>;
  destroyAccountLogo?: Maybe<DestroyAccountLogoPayload>;
  destroyAccountSymbol?: Maybe<DestroyAccountSymbolPayload>;
  destroyBankAccount?: Maybe<DestroyBankAccountPayload>;
  destroyInvoice?: Maybe<DestroyInvoicePayload>;
  destroyInvoiceLine?: Maybe<DestroyInvoiceLinePayload>;
  destroyReceipt?: Maybe<DestroyReceiptPayload>;
  destroyTransfer?: Maybe<DestroyTransferPayload>;
  duplicateInvoice?: Maybe<DuplicateInvoicePayload>;
  onboard?: Maybe<OnboardPayload>;
  registerTeamAccount?: Maybe<RegisterTeamAccountPayload>;
  removeAccountMember?: Maybe<RemoveAccountMemberPayload>;
  resolveInvoice?: Maybe<ResolveInvoicePayload>;
  sendCreditNoteViaEhf?: Maybe<SendCreditNoteViaEhfPayload>;
  sendCreditNoteViaEmail?: Maybe<SendCreditNoteViaEmailPayload>;
  sendInvoiceViaEhf?: Maybe<SendInvoiceViaEhfPayload>;
  sendInvoiceViaEmail?: Maybe<SendInvoiceViaEmailPayload>;
  sendSmsConfirmation?: Maybe<SendSmsConfirmationPayload>;
  sendSupportMessage?: Maybe<SendSupportMessagePayload>;
  setAccountOwner?: Maybe<SetAccountOwnerPayload>;
  setDefaultBankAccount?: Maybe<SetDefaultBankAccountPayload>;
  setDefaultIdentity?: Maybe<SetDefaultIdentityPayload>;
  setEnrollment?: Maybe<SetEnrollmentPayload>;
  setTeamRole?: Maybe<SetTeamRolePayload>;
  submitInvoice?: Maybe<SubmitInvoicePayload>;
  switchAccount?: Maybe<SwitchAccountPayload>;
  unarchiveFreelanceProfile?: Maybe<UnarchiveFreelanceProfilePayload>;
  updateAccount?: Maybe<UpdateAccountPayload>;
  updateAccountMember?: Maybe<UpdateAccountMemberPayload>;
  updateClient?: Maybe<UpdateClientPayload>;
  updateFreelanceProfile?: Maybe<UpdateFreelanceProfilePayload>;
  updateInvoice?: Maybe<UpdateInvoicePayload>;
  updateInvoiceLine?: Maybe<UpdateInvoiceLinePayload>;
  updateTransfer?: Maybe<UpdateTransferPayload>;
  updateUser?: Maybe<UpdateUserPayload>;
  useSessionOtp?: Maybe<UseSessionOtpPayload>;
  verifyPhoneNumber?: Maybe<VerifyPhoneNumberPayload>;
};


export type MutationAddAccountMemberArgs = {
  input: AddAccountMemberInput;
};


export type MutationApproveEnrollmentArgs = {
  input: ApproveEnrollmentInput;
};


export type MutationArchiveClientArgs = {
  input: ArchiveClientInput;
};


export type MutationArchiveFreelanceProfileArgs = {
  input: ArchiveFreelanceProfileInput;
};


export type MutationCancelAccountDeletionArgs = {
  input: CancelAccountDeletionInput;
};


export type MutationCreateBankAccountArgs = {
  input: CreateBankAccountInput;
};


export type MutationCreateClientArgs = {
  input: CreateClientInput;
};


export type MutationCreateCreditNoteArgs = {
  input: CreateCreditNoteInput;
};


export type MutationCreateFreelanceProfileArgs = {
  input: CreateFreelanceProfileInput;
};


export type MutationCreateInvoiceArgs = {
  input: CreateInvoiceInput;
};


export type MutationCreateInvoiceLineArgs = {
  input: CreateInvoiceLineInput;
};


export type MutationCreateJournalArgs = {
  input: CreateJournalInput;
};


export type MutationCreateReceiptArgs = {
  input: CreateReceiptInput;
};


export type MutationCreateSessionOtpArgs = {
  input: CreateSessionOtpInput;
};


export type MutationCreateTeamAccountArgs = {
  input: CreateTeamAccountInput;
};


export type MutationCreateTransferArgs = {
  input: CreateTransferInput;
};


export type MutationCriiptoVerifyArgs = {
  input: CriiptoVerifyInput;
};


export type MutationDeleteAccountArgs = {
  input: DeleteAccountInput;
};


export type MutationDeleteIdentityArgs = {
  input: DeleteIdentityInput;
};


export type MutationDestroyAccountLogoArgs = {
  input: DestroyAccountLogoInput;
};


export type MutationDestroyAccountSymbolArgs = {
  input: DestroyAccountSymbolInput;
};


export type MutationDestroyBankAccountArgs = {
  input: DestroyBankAccountInput;
};


export type MutationDestroyInvoiceArgs = {
  input: DestroyInvoiceInput;
};


export type MutationDestroyInvoiceLineArgs = {
  input: DestroyInvoiceLineInput;
};


export type MutationDestroyReceiptArgs = {
  input: DestroyReceiptInput;
};


export type MutationDestroyTransferArgs = {
  input: DestroyTransferInput;
};


export type MutationDuplicateInvoiceArgs = {
  input: DuplicateInvoiceInput;
};


export type MutationOnboardArgs = {
  input: OnboardInput;
};


export type MutationRegisterTeamAccountArgs = {
  input: RegisterTeamAccountInput;
};


export type MutationRemoveAccountMemberArgs = {
  input: RemoveAccountMemberInput;
};


export type MutationResolveInvoiceArgs = {
  input: ResolveInvoiceInput;
};


export type MutationSendCreditNoteViaEhfArgs = {
  input: SendCreditNoteViaEhfInput;
};


export type MutationSendCreditNoteViaEmailArgs = {
  input: SendCreditNoteViaEmailInput;
};


export type MutationSendInvoiceViaEhfArgs = {
  input: SendInvoiceViaEhfInput;
};


export type MutationSendInvoiceViaEmailArgs = {
  input: SendInvoiceViaEmailInput;
};


export type MutationSendSmsConfirmationArgs = {
  input: SendSmsConfirmationInput;
};


export type MutationSendSupportMessageArgs = {
  input: SendSupportMessageInput;
};


export type MutationSetAccountOwnerArgs = {
  input: SetAccountOwnerInput;
};


export type MutationSetDefaultBankAccountArgs = {
  input: SetDefaultBankAccountInput;
};


export type MutationSetDefaultIdentityArgs = {
  input: SetDefaultIdentityInput;
};


export type MutationSetEnrollmentArgs = {
  input: SetEnrollmentInput;
};


export type MutationSetTeamRoleArgs = {
  input: SetTeamRoleInput;
};


export type MutationSubmitInvoiceArgs = {
  input: SubmitInvoiceInput;
};


export type MutationSwitchAccountArgs = {
  input: SwitchAccountInput;
};


export type MutationUnarchiveFreelanceProfileArgs = {
  input: UnarchiveFreelanceProfileInput;
};


export type MutationUpdateAccountArgs = {
  input: UpdateAccountInput;
};


export type MutationUpdateAccountMemberArgs = {
  input: UpdateAccountMemberInput;
};


export type MutationUpdateClientArgs = {
  input: UpdateClientInput;
};


export type MutationUpdateFreelanceProfileArgs = {
  input: UpdateFreelanceProfileInput;
};


export type MutationUpdateInvoiceArgs = {
  input: UpdateInvoiceInput;
};


export type MutationUpdateInvoiceLineArgs = {
  input: UpdateInvoiceLineInput;
};


export type MutationUpdateTransferArgs = {
  input: UpdateTransferInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUseSessionOtpArgs = {
  input: UseSessionOtpInput;
};


export type MutationVerifyPhoneNumberArgs = {
  input: VerifyPhoneNumberInput;
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  id: Scalars['ID']['output'];
};

export type OccupationCode = Node & {
  __typename?: 'OccupationCode';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  parentCode?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  tagList?: Maybe<Scalars['String']['output']>;
};

export type OccupationCodePagination = {
  __typename?: 'OccupationCodePagination';
  exportPath?: Maybe<Scalars['String']['output']>;
  items: Array<OccupationCode>;
  total: Scalars['Int']['output'];
};

/** Autogenerated input type of Onboard */
export type OnboardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of Onboard. */
export type OnboardPayload = {
  __typename?: 'OnboardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  onboarded: Scalars['Boolean']['output'];
};

export type PhoneNumber = Node & {
  __typename?: 'PhoneNumber';
  countryCode: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  number: Scalars['String']['output'];
  tokenSentAt?: Maybe<Scalars['String']['output']>;
  tokenVerifiedAt?: Maybe<Scalars['String']['output']>;
};

export type PhoneNumberPagination = {
  __typename?: 'PhoneNumberPagination';
  exportPath?: Maybe<Scalars['String']['output']>;
  items: Array<PhoneNumber>;
  total: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  checkSlug: Scalars['Boolean']['output'];
  clients: ClientPagination;
  companies: ListCompanyPagination;
  company?: Maybe<Company>;
  creditNotes: CreditNotePagination;
  freelanceProfiles: FreelanceProfilePagination;
  invoices: InvoicePagination;
  lastUsedPhoneNumber?: Maybe<PhoneNumber>;
  members: AccountPagination;
  /** Fetches an object given its ID. */
  node?: Maybe<Node>;
  occupationCodes: OccupationCodePagination;
  phoneNumbers: PhoneNumberPagination;
  purchases: InvoicePagination;
  refunds: CreditNotePagination;
  relatedTeams: AccountPagination;
  salaryReports: SalaryReportPagination;
  salarySlips: SalarySlipPagination;
  session?: Maybe<Session>;
  suppliers: FreelanceProfilePagination;
};


export type QueryCheckSlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryClientsArgs = {
  filter?: InputMaybe<ClientsFilter>;
  freelanceProfileId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<ClientsSortByEnum>;
};


export type QueryCompaniesArgs = {
  includeSubunits?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompanyArgs = {
  orgNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCreditNotesArgs = {
  filter?: InputMaybe<CreditNotesFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<CreditNotesSortByEnum>;
};


export type QueryFreelanceProfilesArgs = {
  filter?: InputMaybe<FreelanceProfilesFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<FreelanceProfilesSortByEnum>;
};


export type QueryInvoicesArgs = {
  filter?: InputMaybe<InvoicesFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<InvoicesSortByEnum>;
};


export type QueryMembersArgs = {
  filter?: InputMaybe<MembersFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOccupationCodesArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPhoneNumbersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPurchasesArgs = {
  filter?: InputMaybe<InvoicesFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<InvoicesSortByEnum>;
};


export type QueryRefundsArgs = {
  filter?: InputMaybe<CreditNotesFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<CreditNotesSortByEnum>;
};


export type QueryRelatedTeamsArgs = {
  filter?: InputMaybe<RelatedTeamsFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySalaryReportsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySalarySlipsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySuppliersArgs = {
  filter?: InputMaybe<FreelanceProfilesFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<FreelanceProfilesSortByEnum>;
};

export type RangeAttributes = {
  from: Scalars['Int']['input'];
  to: Scalars['Int']['input'];
};

export type Receipt = Node & {
  __typename?: 'Receipt';
  file: Attachment;
  id: Scalars['ID']['output'];
};

export type ReceiptAttributes = {
  file: Base64AttachmentAttributes;
};

export type ReferencePerson = {
  __typename?: 'ReferencePerson';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
};

export type ReferencePersonAttributes = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterTeamAccountAttributes = {
  email: Scalars['EmailField']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  marketingConsent: Scalars['Boolean']['input'];
  necessaryCookiesConsent: Scalars['Boolean']['input'];
  nonProfit?: InputMaybe<Scalars['Boolean']['input']>;
  organizationNumber: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<AccountTagEnum>;
};

/** Autogenerated input type of RegisterTeamAccount */
export type RegisterTeamAccountInput = {
  attributes: RegisterTeamAccountAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RegisterTeamAccount. */
export type RegisterTeamAccountPayload = {
  __typename?: 'RegisterTeamAccountPayload';
  account?: Maybe<Account>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

export type RelatedTeamsFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of RemoveAccountMember */
export type RemoveAccountMemberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveAccountMember. */
export type RemoveAccountMemberPayload = {
  __typename?: 'RemoveAccountMemberPayload';
  account?: Maybe<Account>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of ResolveInvoice */
export type ResolveInvoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ResolveInvoice. */
export type ResolveInvoicePayload = {
  __typename?: 'ResolveInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  invoice?: Maybe<Invoice>;
};

export type SalaryReport = Node & {
  __typename?: 'SalaryReport';
  id: Scalars['ID']['output'];
  payoutAmount: Scalars['Int']['output'];
  pdfDocument?: Maybe<Attachment>;
  salaryTaxAmount: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type SalaryReportPagination = {
  __typename?: 'SalaryReportPagination';
  exportPath?: Maybe<Scalars['String']['output']>;
  items: Array<SalaryReport>;
  total: Scalars['Int']['output'];
};

export type SalarySlip = Node & {
  __typename?: 'SalarySlip';
  id: Scalars['ID']['output'];
  payoutAmount: Scalars['Int']['output'];
  payoutDate: Scalars['String']['output'];
  pdfDocument?: Maybe<Attachment>;
  salaryTax: Scalars['Float']['output'];
  salaryTaxAmount: Scalars['Int']['output'];
};

export type SalarySlipPagination = {
  __typename?: 'SalarySlipPagination';
  exportPath?: Maybe<Scalars['String']['output']>;
  items: Array<SalarySlip>;
  total: Scalars['Int']['output'];
};

/** Autogenerated input type of SendCreditNoteViaEhf */
export type SendCreditNoteViaEhfInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of SendCreditNoteViaEhf. */
export type SendCreditNoteViaEhfPayload = {
  __typename?: 'SendCreditNoteViaEhfPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of SendCreditNoteViaEmail */
export type SendCreditNoteViaEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of SendCreditNoteViaEmail. */
export type SendCreditNoteViaEmailPayload = {
  __typename?: 'SendCreditNoteViaEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of SendInvoiceViaEhf */
export type SendInvoiceViaEhfInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of SendInvoiceViaEhf. */
export type SendInvoiceViaEhfPayload = {
  __typename?: 'SendInvoiceViaEhfPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of SendInvoiceViaEmail */
export type SendInvoiceViaEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of SendInvoiceViaEmail. */
export type SendInvoiceViaEmailPayload = {
  __typename?: 'SendInvoiceViaEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of SendSmsConfirmation */
export type SendSmsConfirmationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  number: Scalars['String']['input'];
};

/** Autogenerated return type of SendSmsConfirmation. */
export type SendSmsConfirmationPayload = {
  __typename?: 'SendSmsConfirmationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of SendSupportMessage */
export type SendSupportMessageInput = {
  clientId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  freelanceProfileId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};

/** Autogenerated return type of SendSupportMessage. */
export type SendSupportMessagePayload = {
  __typename?: 'SendSupportMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

export type Session = {
  __typename?: 'Session';
  account: Account;
  accounts: Array<Account>;
  administrator?: Maybe<Scalars['String']['output']>;
  hasFreelanceProfiles: Scalars['Boolean']['output'];
  hasIdentity: Scalars['Boolean']['output'];
  hasIndividualFreelanceProfile: Scalars['Boolean']['output'];
  needsOnboarding: Scalars['Boolean']['output'];
  phoneNumber?: Maybe<PhoneNumber>;
  role?: Maybe<TeamRoleEnum>;
  user: User;
};

/** Autogenerated input type of SetAccountOwner */
export type SetAccountOwnerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetAccountOwner. */
export type SetAccountOwnerPayload = {
  __typename?: 'SetAccountOwnerPayload';
  account?: Maybe<Account>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of SetDefaultBankAccount */
export type SetDefaultBankAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of SetDefaultBankAccount. */
export type SetDefaultBankAccountPayload = {
  __typename?: 'SetDefaultBankAccountPayload';
  bankAccount?: Maybe<BankAccount>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of SetDefaultIdentity */
export type SetDefaultIdentityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of SetDefaultIdentity. */
export type SetDefaultIdentityPayload = {
  __typename?: 'SetDefaultIdentityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  identity?: Maybe<Identity>;
};

/** Autogenerated input type of SetEnrollment */
export type SetEnrollmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  freelanceProfileId: Scalars['ID']['input'];
  partnerAccountId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetEnrollment. */
export type SetEnrollmentPayload = {
  __typename?: 'SetEnrollmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  enrollment?: Maybe<Enrollment>;
  errors: Array<Error>;
};

/** Autogenerated input type of SetTeamRole */
export type SetTeamRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['ID']['input'];
  role: TeamRoleEnum;
};

/** Autogenerated return type of SetTeamRole. */
export type SetTeamRolePayload = {
  __typename?: 'SetTeamRolePayload';
  account?: Maybe<Account>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of SubmitInvoice */
export type SubmitInvoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of SubmitInvoice. */
export type SubmitInvoicePayload = {
  __typename?: 'SubmitInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  invoice?: Maybe<Invoice>;
};

/** Autogenerated input type of SwitchAccount */
export type SwitchAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of SwitchAccount. */
export type SwitchAccountPayload = {
  __typename?: 'SwitchAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  token?: Maybe<Scalars['String']['output']>;
};

export type TaskReport = WorkReport & {
  __typename?: 'TaskReport';
  endDate: Scalars['String']['output'];
  hours: Scalars['Float']['output'];
  startDate: Scalars['String']['output'];
  type: WorkReportTypeEnum;
};

export enum TeamRoleEnum {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Owner = 'OWNER'
}

export type TimeReport = WorkReport & {
  __typename?: 'TimeReport';
  endDate: Scalars['String']['output'];
  endTime: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
  type: WorkReportTypeEnum;
};

export type Transfer = Node & {
  __typename?: 'Transfer';
  amount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fromFinanceAccount?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice: Invoice;
  toFinanceAccount?: Maybe<Scalars['String']['output']>;
};

export type UiFlags = {
  __typename?: 'UiFlags';
  shownIds: Array<Scalars['String']['output']>;
};

export type UiFlagsAttributes = {
  shownIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated input type of UnarchiveFreelanceProfile */
export type UnarchiveFreelanceProfileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UnarchiveFreelanceProfile. */
export type UnarchiveFreelanceProfilePayload = {
  __typename?: 'UnarchiveFreelanceProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  freelanceProfile: FreelanceProfile;
};

export type UpdateAccountAttributes = {
  address?: InputMaybe<AddressAttributes>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  industrySector?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<LanguageEnum>;
  logo?: InputMaybe<Base64AttachmentAttributes>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<Base64AttachmentAttributes>;
  uiFlags?: InputMaybe<UiFlagsAttributes>;
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateAccount */
export type UpdateAccountInput = {
  attributes: UpdateAccountAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  personal?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of UpdateAccountMember */
export type UpdateAccountMemberInput = {
  attributes: UpdateMemberAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateAccountMember. */
export type UpdateAccountMemberPayload = {
  __typename?: 'UpdateAccountMemberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  member?: Maybe<Account>;
};

/** Autogenerated return type of UpdateAccount. */
export type UpdateAccountPayload = {
  __typename?: 'UpdateAccountPayload';
  account?: Maybe<Account>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

export type UpdateClientAttributes = {
  address?: InputMaybe<AddressAttributes>;
  clientNumber?: InputMaybe<Scalars['Int']['input']>;
  clientType?: InputMaybe<ClientTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationalRegisterCheck?: InputMaybe<Scalars['Boolean']['input']>;
  orgNumber?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preferredDeliveryMethod?: InputMaybe<ClientPreferredDeliveryMethodEnum>;
  referencePeople?: InputMaybe<Array<ReferencePersonAttributes>>;
};

/** Autogenerated input type of UpdateClient */
export type UpdateClientInput = {
  attributes: UpdateClientAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateClient. */
export type UpdateClientPayload = {
  __typename?: 'UpdateClientPayload';
  client?: Maybe<Client>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

export type UpdateFreelanceProfileAttributes = {
  address?: InputMaybe<AddressAttributes>;
  bankAccount?: InputMaybe<BankAccountAttributes>;
  invoiceLogo?: InputMaybe<Base64AttachmentAttributes>;
  invoiceStartingNumber?: InputMaybe<Scalars['Int']['input']>;
  journalClosedMonth?: InputMaybe<Scalars['String']['input']>;
  journalFormat?: InputMaybe<JournalFormatEnum>;
  referencePeople?: InputMaybe<Array<ReferencePersonAttributes>>;
};

/** Autogenerated input type of UpdateFreelanceProfile */
export type UpdateFreelanceProfileInput = {
  attributes: UpdateFreelanceProfileAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateFreelanceProfile. */
export type UpdateFreelanceProfilePayload = {
  __typename?: 'UpdateFreelanceProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  freelanceProfile?: Maybe<FreelanceProfile>;
};

export type UpdateInvoiceAttributes = {
  bankAccountId?: InputMaybe<Scalars['ID']['input']>;
  buyerReference?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  clientReferencePerson?: InputMaybe<ReferencePersonAttributes>;
  dueOn?: InputMaybe<Scalars['String']['input']>;
  freelanceProfileId?: InputMaybe<Scalars['ID']['input']>;
  invoicedOn?: InputMaybe<Scalars['String']['input']>;
  lines?: InputMaybe<Array<BulkInvoiceLineAttributes>>;
  orderReference?: InputMaybe<Scalars['String']['input']>;
  senderReferencePerson?: InputMaybe<ReferencePersonAttributes>;
};

/** Autogenerated input type of UpdateInvoice */
export type UpdateInvoiceInput = {
  attributes: UpdateInvoiceAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateInvoiceLineAttributes = {
  addressFrom?: InputMaybe<Scalars['String']['input']>;
  addressTo?: InputMaybe<Scalars['String']['input']>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dietNonTaxableUnitPrice?: InputMaybe<Scalars['Int']['input']>;
  dietTaxableUnitPrice?: InputMaybe<Scalars['Int']['input']>;
  lineType?: InputMaybe<LineTypeEnum>;
  occupationCodeId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Int']['input']>;
  vatRate?: InputMaybe<Scalars['Float']['input']>;
  workInvoiceLineId?: InputMaybe<Scalars['ID']['input']>;
  workReport?: InputMaybe<WorkReportAttributes>;
};

/** Autogenerated input type of UpdateInvoiceLine */
export type UpdateInvoiceLineInput = {
  attributes: UpdateInvoiceLineAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateInvoiceLine. */
export type UpdateInvoiceLinePayload = {
  __typename?: 'UpdateInvoiceLinePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  invoiceLine?: Maybe<InvoiceLine>;
};

/** Autogenerated return type of UpdateInvoice. */
export type UpdateInvoicePayload = {
  __typename?: 'UpdateInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  invoice?: Maybe<Invoice>;
};

export type UpdateMemberAttributes = {
  role: TeamRoleEnum;
};

export type UpdateTransferAttributes = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fromFinanceAccount?: InputMaybe<Scalars['String']['input']>;
  toFinanceAccount?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateTransfer */
export type UpdateTransferInput = {
  attributes: UpdateTransferAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateTransfer. */
export type UpdateTransferPayload = {
  __typename?: 'UpdateTransferPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  transfer?: Maybe<Transfer>;
};

export type UpdateUserAttributes = {
  marketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  necessaryCookiesConsent?: InputMaybe<Scalars['Boolean']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateUser */
export type UpdateUserInput = {
  attributes: UpdateUserAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateUser. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  user?: Maybe<User>;
};

/** Autogenerated input type of UseSessionOtp */
export type UseSessionOtpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  otp: Scalars['String']['input'];
};

/** Autogenerated return type of UseSessionOtp. */
export type UseSessionOtpPayload = {
  __typename?: 'UseSessionOtpPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deepLink?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  token?: Maybe<Scalars['String']['output']>;
};

export type User = Node & {
  __typename?: 'User';
  confirmed: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language: LanguageEnum;
  lastName?: Maybe<Scalars['String']['output']>;
  marketingConsent: Scalars['Boolean']['output'];
  necessaryCookiesConsent: Scalars['Boolean']['output'];
  occupation?: Maybe<Scalars['String']['output']>;
  referrer?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of VerifyPhoneNumber */
export type VerifyPhoneNumberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  number: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

/** Autogenerated return type of VerifyPhoneNumber. */
export type VerifyPhoneNumberPayload = {
  __typename?: 'VerifyPhoneNumberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

export type WorkInvoiceLine = InvoiceLine & Node & {
  __typename?: 'WorkInvoiceLine';
  amount: Scalars['Int']['output'];
  collapsed: Scalars['Boolean']['output'];
  dependentLines: Array<InvoiceLine>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice: Invoice;
  lineType: LineTypeEnum;
  occupationCode: OccupationCode;
  quantity: Scalars['Float']['output'];
  remainingQuantity: Scalars['Float']['output'];
  unitPrice: Scalars['Int']['output'];
  vat: Scalars['Int']['output'];
  vatRate: Scalars['Float']['output'];
  workReport: WorkReport;
};

export type WorkReport = {
  endDate: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
  type: WorkReportTypeEnum;
};

export type WorkReportAttributes = {
  endDate: Scalars['String']['input'];
  endTime?: InputMaybe<Scalars['String']['input']>;
  hours?: InputMaybe<Scalars['Float']['input']>;
  startDate: Scalars['String']['input'];
  startTime?: InputMaybe<Scalars['String']['input']>;
  type: WorkReportTypeEnum;
};

export enum WorkReportTypeEnum {
  Task = 'TASK',
  Time = 'TIME'
}
